import script from "./VTableHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./VTableHeader.vue?vue&type=script&setup=true&lang=js"

import "./VTableHeader.vue?vue&type=style&index=0&id=10110794&scoped=true&lang=less"

import exportComponent from "D:\\develop\\app\\cw\\financial\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10110794"]])

export default __exports__